<template>
  <div>
    <LmListV2
      ref='LmInboxListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Bandejas de Entrada',
      gqlField: 'Inbox',
      gqlVariables: {
        q: '*',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[InboxESSortEnum]) {
      Inbox(
          titleList: "Listado de Bandejas de Entrada"
          q: $q
          perPage: 10
          page: $page
          sort: $sort
          metaSearch: "*"
          opts: {
            lenient: true
          }
          lmPathActions: [{to:"/inboxbuilder/editar/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
          lmModalActions: []
          buttonLinks: [{value:"Nuevo",to:"/inboxbuilder/nuevo",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info"}]

          ) {
          count
          searcher
          tableItemsTotal
          titleList
          table {
            items {
              name,deleted,createdAt,updatedAt,updatedBy,actions
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`,
      searchOnFieldsSelected: [
        'name',
        'deleted',
        'createdAt',
        'updatedAt',
        'createdBy',
        'updatedBy',
        'actions'
      ],
      searchOnFieldsToSelected: [
        'name',
        'deleted',
        'createdAt',
        'updatedAt',
        'updatedBy',
        'actions'
      ],
      items: [
        {
          name: 'name'
        },
        {
          name: 'deleted'
        },
        {
          name: 'createdAt'
        },
        {
          name: 'updatedAt'
        },
        {
          name: 'createdBy'
        },
        {
          name: 'updatedBy'
        },
        {
          name: 'actions'
        }
      ],
      mode: {
        table: true,
        map: false,
        box: false
      },
      fields: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: false
        },
        {
          key: 'createdAt',
          label: 'Creado',
          sortable: true
        },
        {
          key: 'updatedAt',
          label: 'Actualizado',
          sortable: true
        },
        {
          key: 'updatedBy',
          label: 'Actualizado por',
          sortable: true
        },
        {
          key: 'deleted',
          label: 'En baja lógica',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }
      ]
    }
  }
}
</script>
